import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Eye, EyeOff } from 'lucide-react';
import { DefaultSheet, SheetBody, DefaultTable, DropdownMenuItem, ButtonIcon } from 'twyne-new.ui'

import { formatDateTime } from 'utils'

import { TruncateWithTooltipFormatter } from '../Grid/components/Table/formatters';

const propTypes = {
  loadVersions: PropTypes.func,
  onView: PropTypes.func,
  number: PropTypes.number,
};

export default function Version({ loadVersions, onView, number }) {
  const [options, setOptions] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (modalOpen) {
      if (options) return
      loadVersions().then(versions => {
        setOptions(versions)
      })
    }
  }, [modalOpen])

  const handleView = data => {
    setModalOpen(false)
    onView(data)
  }

  const toggle = () => setModalOpen(!modalOpen)

  const TriggerButton = () => <>
    <DropdownMenuItem
      onSelect={e => e.preventDefault()}
      onClick={toggle}
    >
      Versions List
    </DropdownMenuItem>
  </>

  return <>
    <DefaultSheet
      title='Versions'
      triggerProps={{ asChild: true }}
      trigger={<TriggerButton />}
      wrapperProps={{ open: modalOpen, onOpenChange: open => !open && toggle() }}
    >
      <SheetBody>
        <Table data={options} onView={handleView} versionNumber={number} />
      </SheetBody>
    </DefaultSheet>
  </>
}

function Table({ data, onView, versionNumber }) {
  const actions = (_, row) => {
    const active = versionNumber == row.version
    return <div>
      <ButtonIcon content={active ? 'Close View' : 'View'} variant='outline' color='accent' onClick={() => onView(!active && row.data)}>
        {active ? <EyeOff size={16} /> : <Eye size={16} />}
      </ButtonIcon>
    </div>
  }
  const columns = [
    {
      dataField: 'version',
      text: "Number",
    }, {
      dataField: 'description',
      text: "Description",
      formatter: cell => <TruncateWithTooltipFormatter className='max-w-50' value={cell} />,
    }, {
      dataField: 'user',
      formatter: cell => `${cell?.first_name} ${cell?.last_name}`,
      text: "User",
    }, {
      dataField: 'updated_at',
      text: "Last modified",
      formatter: cell => formatDateTime(cell),
    }, {
      dataField: 'active',
      className: 'w-8',
      text: "",
      formatter: actions,
    },
  ]

  return <DefaultTable
    keyField="id"
    data={data || []}
    columns={columns}
    bordered={false}
    noDataIndication={() => 'No versions yet.'}
  />
}

Version.propTypes = propTypes
Version.defaultProps = {}
